// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;       /* horizontal centering */
  justify-content: center;   /* vertical centering */
  height: 100vh;             /* full viewport height */
}

.login-container input,
.login-container button {
  margin-bottom: 1rem;       /* spacing between elements */
  width: 200px;              /* optional fixed width */
  padding: 0.5rem;           /* nicer spacing inside inputs */
}

.login-container button {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,QAAQ,yBAAyB;EACpD,uBAAuB,IAAI,uBAAuB;EAClD,aAAa,cAAc,yBAAyB;AACtD;;AAEA;;EAEE,mBAAmB,QAAQ,6BAA6B;EACxD,YAAY,eAAe,yBAAyB;EACpD,eAAe,YAAY,gCAAgC;AAC7D;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;       /* horizontal centering */\n  justify-content: center;   /* vertical centering */\n  height: 100vh;             /* full viewport height */\n}\n\n.login-container input,\n.login-container button {\n  margin-bottom: 1rem;       /* spacing between elements */\n  width: 200px;              /* optional fixed width */\n  padding: 0.5rem;           /* nicer spacing inside inputs */\n}\n\n.login-container button {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
